<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    eyebrow: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    // light text on the blue gradient
    inverted: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    alignStartOnDesktop: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'h2',
    },
  });

  const eyebrowClasses = computed(() => [
    props.large
      ? 'text-[18px]/5.5 lg:text-[20px]/6'
      : 'text-[14px]/4 md:text-[16px]/5 lg:text-[20px]/6',
    props.inverted ? 'text-pale-sky' : 'text-cobalt',
  ]);

  const titleClasses = computed(() => {
    if (props.inverted) {
      return [
        'text-[28px]/8.5 text-white md:text-[32px]/10 lg:text-[38px]/11.5',
        props.eyebrow && 'mt-6 lg:mt-8',
      ];
    }
    return [
      'text-ink',
      props.large ? 'text-[42px]/13' : 'text-[34px]/10 md:text-[38px]/11 lg:text-[42px]/13',
      props.eyebrow && (props.large ? 'mt-5 lg:mt-6' : 'mt-3 lg:mt-6'),
    ];
  });
</script>

<template>
  <div
    :class="[
      'flex flex-col items-center text-center',
      alignStartOnDesktop && 'lg:items-start lg:text-left',
    ]"
  >
    <p v-if="eyebrow" :class="['font-semibold tracking-[0.05em] uppercase', eyebrowClasses]">
      {{ eyebrow }}
    </p>
    <component :is="tag" :class="['font-bold text-balance whitespace-pre-line', titleClasses]">
      {{ title }}
    </component>
  </div>
</template>
